<div [ngStyle]="{'min-height': '115px', 'min-width': '200px', 'display': 'block'}">
  <ng-container *ngIf="highChartOptions; else loadingChart">
    <highcharts-chart
      [Highcharts]="highChart"
      [options]="highChartOptions"></highcharts-chart>
  </ng-container>

  <ng-template #loadingChart>
    <div class="nz-spin-h mt-1 mb-0">
      <nz-spin></nz-spin>
    </div>
  </ng-template>
</div>

